module.exports = __webpack_public_path__ + "img/9791188502165.6bfac4c8.jpg";